import { Directive, Input, TemplateRef, ViewContainerRef, inject } from "@angular/core";
import { Module } from "../classes/flow/base/Module";
import { ENVIRONMENT } from "../../environments/environment";

@Directive({ selector: "[appModule]" })
export class ModuleDirective {
  private template = inject<TemplateRef<unknown>>(TemplateRef);
  private container = inject(ViewContainerRef);

  @Input() set appModule(module: Module) {
    if (ENVIRONMENT.MODULES.includes(module)) {
      this.container.createEmbeddedView(this.template);
    } else {
      this.container.clear();
    }
  }
}
